namespace GeniuzPOS.Lookups {
    export interface VwIcWhsRow {
        Id?: number;
        WhsId?: string;
        WhsName?: string;
        WhsType?: number;
        ShopId?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        NameProperty?: string;
    }

    export namespace VwIcWhsRow {
        export const idProperty = 'WhsId';
        export const nameProperty = 'NameProperty';
        export const localTextPrefix = 'Lookups.VwIcWhs';
        export const lookupKey = 'VwIcWhsRow';

        export function getLookup(): Q.Lookup<VwIcWhsRow> {
            return Q.getLookup<VwIcWhsRow>('VwIcWhsRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            NameProperty = "NameProperty"
        }
    }
}
